import { FieldLabel } from "./GraphicsHelpers";
import { STYLES, RATIOS } from "@/lib/graphicsConstants";

export function StyleRatioSection({ style, setStyle, ratio, setRatio }) {
  return (
    <>
      {/* Visual Style */}
      <div>
        <FieldLabel required>Visual Style</FieldLabel>
        <div className="grid grid-cols-2 sm:grid-cols-5 gap-2" data-testid="gfx-styles">
          {STYLES.map(s => (
            <button key={s.key} onClick={() => setStyle(s.key)}
              data-testid={`gfx-style-${s.key.toLowerCase().replace(/[\s\/]+/g, "-")}`}
              className={`text-left p-2.5 rounded-xl border transition-all ${
                style === s.key
                  ? "bg-violet-500/10 border-violet-500/50 ring-1 ring-violet-500/30"
                  : "bg-[var(--bg-card)] border-[var(--border)] hover:border-[var(--text-muted)]"
              }`}>
              <span className={`block text-[11px] font-semibold leading-tight ${style === s.key ? "text-violet-400" : "text-[var(--text-primary)]"}`}>{s.label}</span>
              <span className="block text-[9px] text-[var(--text-muted)] mt-0.5 leading-tight">{s.desc}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Aspect Ratio */}
      <div>
        <FieldLabel required>Aspect Ratio</FieldLabel>
        <div className="flex flex-wrap gap-2" data-testid="gfx-ratios">
          {RATIOS.map(r => (
            <button key={r.key} onClick={() => setRatio(r.key)}
              data-testid={`gfx-ratio-${r.key.replace(":", "x")}`}
              className={`px-3 py-2 rounded-lg text-xs font-medium border transition-all ${
                ratio === r.key
                  ? "bg-violet-500/10 border-violet-500/50 text-violet-400"
                  : "bg-[var(--bg-card)] border-[var(--border)] text-[var(--text-secondary)] hover:border-[var(--text-muted)]"
              }`}>
              {r.label}
            </button>
          ))}
        </div>
      </div>
    </>
  );
}
